module.exports = __webpack_public_path__ + "static/media/randalls.58f3724b.svg";